import { useCallback, useMemo } from "react";
var usePagination = function () {
    var onChangePage = useCallback(function (setPage, i, setCertificateTrigger) {
        setPage(i);
        setCertificateTrigger(true);
    }, []);
    var onChangeItemPerPage = useCallback(function (setLimit, i, setCertificateTrigger) {
        setLimit(i);
        setCertificateTrigger(true);
    }, []);
    return useMemo(function () { return ({
        onChangePage: onChangePage,
        onChangeItemPerPage: onChangeItemPerPage,
    }); }, [onChangePage, onChangeItemPerPage]);
};
export default usePagination;
